module.exports = __webpack_public_path__ + "img/zz3.8329712c.png";